type ApolloOperationReportInput = {
  operationName?: unknown;
  variables?: unknown;
};

type ApolloErrorConsoleSummaryInput = {
  graphQLErrorCount: number;
  hasNetworkError: boolean;
  operationName?: unknown;
};

/** Backend refusal when a member edits the email of the contact they sign in as. */
export const OWN_LOGIN_EMAIL_REFUSAL = "This email is your Member Dashboard login.";

/**
 * Backend refusal of the old credential tools for a Chamber Member Pro member
 * whose logins belong to its contacts. It is an expected answer, not a fault.
 */
export const MEMBER_CONTACT_LOGINS_MESSAGE =
  "This member's Member Dashboard logins belong to its contacts. Use Update Member > Member Contacts in Chamber Member Pro to send credentials or reset a password.";

export const isMemberContactLoginsRefusal = (message: unknown): boolean =>
  typeof message === "string" &&
  message.startsWith("This member's Member Dashboard logins belong to its contacts.");

const locallyHandledApolloErrorOperations = new Set([
  "reactivateMemberProfileAndPerksBannersForChamberMember",
  "reactivateBannerForCategoryAdvertisingBanner",
  "getChamberForMemberLogin",
  "recordCmpMemberDashboardLogin",
  "recordCpaDashboardAccess",
  "sendLoginInfoEmailToChamberMember",
  "ActivateCmpMember",
  "SuspendCmpMember",
  "getCmpMemberInvoices",
  "getCmpMemberInvoiceDetail",
  "getCmpMemberInvoiceDocument",
  "startCmpMemberInvoiceCheckout",
]);

const getOperationName = (operationName: unknown): string =>
  typeof operationName === "string" && operationName.trim()
    ? operationName.trim()
    : "unknown";

/**
 * Error reports can identify the GraphQL input shape, but must not include
 * customer or credential values from the operation variables.
 */
export const getApolloOperationReportContext = ({
  operationName,
  variables,
}: ApolloOperationReportInput): {
  operationName: string;
  variableNames: string[];
} => ({
  operationName: getOperationName(operationName),
  variableNames:
    variables && typeof variables === "object" && !Array.isArray(variables)
      ? Object.keys(variables as Record<string, unknown>).sort()
      : [],
});

export const getApolloErrorConsoleSummary = ({
  graphQLErrorCount,
  hasNetworkError,
  operationName,
}: ApolloErrorConsoleSummaryInput): {
  graphQLErrorCount: number;
  hasNetworkError: boolean;
  operationName: string;
} => ({
  graphQLErrorCount,
  hasNetworkError,
  operationName: getOperationName(operationName),
});

export const isApolloErrorHandledLocally = (
  operationName: unknown
): boolean =>
  typeof operationName === "string" &&
  locallyHandledApolloErrorOperations.has(operationName);
